import { createContext } from 'react'
import { HistoryContextProps } from '../HistoryEntry/HistoryContext'
import HistoryEntry from '../HistoryEntry/HistoryEntry'

export const EmploymentHistoryContext = createContext<HistoryContextProps<EmploymentHistoryEntry>>({
  dispatch: () => { }
})

export interface EmployerDetailsEntry {
  jobTitle?: string
  companyName?: string
  location?: string
}

export const areEmployerDetailsComplete = (employerDetails?: EmployerDetailsEntry) => !!employerDetails
  && !!employerDetails.jobTitle
  && !!employerDetails.companyName
  && !!employerDetails.location

export interface EmploymentHistoryEntry extends HistoryEntry {
  employmentSituation?: string
  employerDetails?: EmployerDetailsEntry
}

export interface EmploymentEntryErrors {
  jobTitle?: string,
  companyName?: string,
  location?: string,
  years?: string,
  months?: string
  duration?: string,
}
export interface EmploymentHistoryState {
  entries: Record<string, EmploymentHistoryEntry>
  questionToEdit?: string
  questionChangeAction?: 'next' | 'prev'
}
